import { getYoutubeID } from "../../utils";

const YoutubeEmbed = ({ url, className = "", fill = "width" }) => {
    const id = getYoutubeID(url);
    if (!id) return null;

    const sizing =
        fill === "height"
            ? "h-full w-auto aspect-video"
            : fill === "container"
              ? "h-full w-full"
              : "w-full aspect-video";

    return (
        <div className={`relative overflow-hidden ${sizing} ${className}`}>
            <iframe
                className="absolute inset-0 h-full w-full border-0"
                src={`https://www.youtube.com/embed/${id}`}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Embedded youtube"
            />
        </div>
    );
};

export default YoutubeEmbed;
